import ReactDOM from 'react-dom/client';
import './index.module.scss';
import './styles/themeColors.scss';
import Root from './components/Root';
import { store } from "./config/store";
import { datadogRum } from '@datadog/browser-rum';
import { dev } from './config/api';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-NFMCK8VM'
}

if(!dev){
  datadogRum.init({
    applicationId: 'a2ed7ecd-c9f7-4d90-a87e-8bf81d871711',
    clientToken: 'pubd68e4182772e9996491667899a2d6019',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'linze-citroen-web',
    env: process.env.REACT_APP_NODE_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true
})
  datadogRum.startSessionReplayRecording();
}
TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if(window?.Cypress){
  window.store = store;
}

root.render(<Root/>);